import { create } from "zustand";

import type { JobSnapshot } from "@/types";

interface JobsState {
  jobs: JobSnapshot[];
  loading: boolean;
  currentLimit: number;
  lastTenantId: string | null;
  setJobs: (jobs: JobSnapshot[]) => void;
  setLoading: (loading: boolean) => void;
  setLimit: (limit: number) => void;
  setLastTenantId: (tenantId: string | null) => void;
  clear: () => void;
}

const DEFAULT_LIMIT = 50;

export const useJobsStore = create<JobsState>((set) => ({
  jobs: [],
  loading: false,
  currentLimit: DEFAULT_LIMIT,
  lastTenantId: null,
  setJobs: (jobs) => set({ jobs: [...jobs] }),
  setLoading: (loading) => set({ loading }),
  setLimit: (currentLimit) => set({ currentLimit }),
  setLastTenantId: (lastTenantId) => set({ lastTenantId }),
  clear: () => set({ jobs: [], loading: false }),
}));
